
import { ref, uploadBytes, getBytes } from "firebase/storage";
import { collection, getDocs, setDoc, getDoc, addDoc, doc, onSnapshot, deleteDoc, updateDoc } from "firebase/firestore";
import { httpsCallable } from 'firebase/functions'
import { Configuration, OpenAIApi } from "openai";

const cors = require('cors')({ origin: true });

const ab2str = (buf) => {return new TextDecoder().decode(buf);}

const getFromStorage = async (id,state) => {
	return state.fromStorage(id)
}

const sendResult = (job,result,state) => {
//	 console.log("*** ==> *** Sending results",job.projID)
	 return new Promise (resolve => {
			 const sendback = {projID: job.projID, jobID: job.jobID, response: result}
			 setDoc(doc(state.getFire().db,"projects",job.projID,"results",job.jobID),sendback)
			 .then(()=>{resolve (true)})
   })
}

// ==== OPEN_AI helpers ===

const openAIProxy = async (params,state) => {
	 console.log ("IS STATE IN A GOOG STATE?",state.getFire())
	 try {
	 	const proxyFn = httpsCallable(state.getFire().functions,"externalJobs-proxyForOpenAI")
	 	console.log("$$$$$$$$$$$$$$$$$$$$", params)
    const response = await proxyFn({params:params});
    console.log("%%%%%%%%%%%%%%%%%%%%",response)
    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Something went wrong locally here in the client.");
  }
}

const openAI_one = async (openai,msgs,temp,state) => {
	return new Promise (async resolve => {
		  const params = {
		        model: "gpt-3.5-turbo",
		        messages: msgs,
		        "temperature": temp,
		        "max_tokens": 1500,
		        "frequency_penalty": 0,
		        "presence_penalty": 0
		      }
		  try {
		  	// Decide whether to run with proxy function or from local ENV
		  	  var completion = null;

		  	  //*********** WARNING, WATCH OUT, MULTI USER, DANGER, WHAT'S UP.... this should use the Proxy function when finally deployed.
		      if (false) {
		      	console.log("DANGER - using LOCAL ENV for Key")
		      	const temp = await openai.createChatCompletion(params);
		      	completion = temp.data
		      }
		      else {
		      	console.log("Using Firebase proxy function for openAI key")
		      	const temp = await openAIProxy(params,state)
		      	console.log("***************************** USEFULL *********",completion)
		      	completion = temp.data.response
		      }

		      var toks =  completion.usage.total_tokens
		      console.log("ONE RESULT::",completion.choices[0].message.content.substr(0,25))
		      resolve({result:completion.choices[0].message.content,tokens:toks});
		    }
		    catch (error) {
		    	console.log("TROUBLE WITH OPEN AI CALL")
		      if (error.response) {
		        console.log(error.response.status);
		        console.log(error.response.data);
		      } else {
		        console.log(error.message);
		      }
		      resolve ({result:"error:"+error.message,tokens:0})
		    }  
	}) 
}

const StringListToHTML = (arr) => {
  var res = ""
  for (var i =0; i<arr.length; i++) {
    res = res+"<p>"+arr[i].replace(/\n|\r/g, "")+"</p>"
  }
  return res
}

const openAI_chunk_and_run = async (data,msgs,temp,state) => {
	return new Promise (async resolve => {
		  const openai_key = process.env.REACT_APP_OPENAI_KEY
		 // console.log("****************************************************",openai_key)
      const configuration = new Configuration ({apiKey: openai_key})
      const openai = new OpenAIApi(configuration)
      const chunkData = (book) => {
          const maxtoken = 4096
          const respsize = 1500
          const chunksize = (maxtoken-respsize)*3
          var res = []
          var startindex = 0
          while (startindex <= book.length) {
            // try to find a good place to break (on a <p> tag)
            var endPoint = book.length
            if (startindex + chunksize < book.length) 
              endPoint = book.substr(0,startindex+chunksize).lastIndexOf('<p>')
            if (endPoint-startindex < chunksize/2) endPoint = startindex+chunksize

            res.push(book.substr(startindex,endPoint-startindex))
            startindex = endPoint
          }
          console.log("TOTAL CHUNKS IS",res.length,"for $",res.length*0.008)
          return res
      }
      const replaceChunk = (msgs,c) => {
        const msgcopy = JSON.parse(JSON.stringify(msgs))
        return (msgcopy.map((m)=>{return({role:m.role,content:m.content.replace("<<CHUNK>>",c)})}))
      }
      const replaceSoFar = (sofar,c) => {
      	const msgcopy = JSON.parse(JSON.stringify(msgs));
        return (msgcopy.map((m)=>{return({role:m.role,content:m.content.replace("<<SOFAR>>",c)})}))
       }
      var sofar = "nothing"
      const chunks = chunkData(data)
      // ******
      // const LIMIT = chunks.length
      var LIMIT = Math.min(6,chunks.length)
      const res = []
      var n = 0
      while (n<LIMIT) {
        const submsg = replaceChunk(msgs,chunks[n])
        const submsg2 = replaceSoFar(msgs,sofar)
        const newr   = await openAI_one(openai,submsg,temp,state)
        sofar = newr.result
        res.push(newr.result)
        n = n + 1
      }
      resolve (StringListToHTML(res))
	})
}

// OPENAI Story2Summary

const OPENAI_Story_Summary = async (job,state) => {
  const story = await getFromStorage(job.assets[0].data.primary.value,state)
  const temp = "params" in job && "temp" in job.params ? job.params.temp : 0.3
  console.log("TEMPERATURE IS",temp)
  const response = {
		  display: "Story to Summary",
	    ProviderName: "OpenAI",
	    ProviderID: "OpenAI Key",
	    Billing: 0,
  }
  const result = await openAI_chunk_and_run(
      story,  // content
      [
          {role:'system',content:'You are a helpful assistant who creates detailed summaries.'},
          {role:'user',content:"Generate a detailed summary of the following:/n/n<<CHUNK>>/n/nDETAILED SUMMARY:"},
      ],
      temp,  // temp
      state,
    )
  response.primary= result
  await sendResult(job,response,state)
  console.log("Complete the job: OPENAI_Story_Summary")
}

const OPENAI_Scene_Process = async (job,state,msgs) => {
	console.log("AND the job is.......",job)

  const storyAsset = job.assets.find((a)=>a.asset === "Story")
  const scenesAsset = job.assets.find((a)=>a.asset === "Scene")

  const story = await getFromStorage(storyAsset.data.primary.value,state)
  const temp = "params" in job && "temp" in job.params ? job.params.temp : 0.3
  console.log("TEMPERATURE IS",temp)

	const response = {
		  display: "Scene Component",
	    ProviderName: "OpenAI",
	    ProviderID: "OpenAI Key",
	    Billing: 0,
  }
  const scenes = scenesAsset.data.entries
  const al = Array.isArray(job.service.outputs) ? job.service.outputs : [job.service.outputs]	// Should be ["Summary"] in this case
  const al0 = al[0]
  const al00 = al0.split('.')
  const al00n = al00[al00.length-1]
  const newdata = []
  var i = 0
  while (i<scenes.length) {
  	console.log("THIS SCENE IS::",i,scenes[i].Index,scenes[i].Index.start,scenes[i].Index.end,
  		  story.substring(scenes[i].Index.start,scenes[i].Index.end).substr(0,50))
  //	 const result = {"Hello":"Hello"}
  	 const result = await openAI_chunk_and_run(
      story.substring(scenes[i].Index.start,scenes[i].Index.end),  // content
      msgs,
      temp,  // temp
      state,
    )
  	const newentry = {id:scenes[i].id}
  	newentry[al00n] = result
  	newdata.push(newentry)
  	i = i+1;
  }
  response.entries = newdata
  console.log("Sending summary response",response.length)
	await sendResult(job,response,state) 
}

const OPENAI_Scene_Summary = async (job,state) => {
	OPENAI_Scene_Process(job,state,
		  [
          {role:'system',content:'You are a helpful assistant who creates detailed summaries.'},
          {role:'user',content:"Generate a detailed summary of the following:/n/n<<CHUNK>>/n/nDETAILED SUMMARY:"},
      ]
		)
	/*
	console.log("AND the job is.......",job)

  const storyAsset = job.assets.find((a)=>a.asset === "Story")
  const scenesAsset = job.assets.find((a)=>a.asset === "Scene")

  const story = await getFromStorage(storyAsset.data.primary.value,state)
  const temp = "params" in job && "temp" in job.params ? job.params.temp : 0.3
  console.log("TEMPERATURE IS",temp)

	const response = {
		  display: "Scene to Summary",
	    ProviderName: "OpenAI",
	    ProviderID: "OpenAI Key",
	    Billing: 0,
  }
  const scenes = scenesAsset.data.entries
  const al = Array.isArray(job.service.outputs) ? job.service.outputs : [job.service.outputs]	// Should be ["Summary"] in this case
  const al0 = al[0]
  const al00 = al0.split('.')
  const al00n = al00[al00.length-1]
  console.log("Scene2Summary generates",al);
  const newdata = []
  var i = 0
  while (i<scenes.length) {
  	console.log("First scene to go is",story.substr(scenes[i].start,scenes[i].end))
  	 const result = await openAI_chunk_and_run(
      story.substr(scenes[i].start,scenes[i].end),  // content
      [
          {role:'system',content:'You are a helpful assistant who creates detailed summaries.'},
          {role:'user',content:"Generate a detailed summary of the following:/n/n<<CHUNK>>/n/nDETAILED SUMMARY:"},
      ],
      temp,  // temp
      state,
    )
  	const newentry = {id:scenes[i].id}
  	newentry[al00n] = result
  	newdata.push(newentry)
  	i = i+1;
  }
  response.entries = newdata
  console.log("Sending summary response",response.length)
	await sendResult(job,response,state) 
	*/
}

const OPENAI_Scene_Locations = async (job,state) => {
		OPENAI_Scene_Process(job,state,
		  [
          {role:'system',content:'You are a helpful assistant who understands the settings and locations in books and ignores html tags.'},
          {role:'user',content:'You return only valid JSON with no other text. Each location has JSON of the form {locationName:TheLab,locationAttributes[Building,City]},'},
          {role:'system', content:'Here is what we know so far: <<SOFAR>>'},
          {role:'user',content:"List all locations and their attributes in the following text:/n/n<<CHUNK>>/nJSON LIST OF LOCATIONS"},
       ]
		)
}

const OPENAI_Scene_Dialog = async (job,state) => {
		OPENAI_Scene_Process(job,state,
		  [
          {role:'system',content:'You are a helpful assistant who understands important dialog in books and ignores html tags.'},
          {role:'system', content:'Here is what we know so far: <<SOFAR>>'},
          {role:'user',content:"Extract the dialog, and who is speaking, from the following. If there is no relevant dialog, invent dialog that illuminates the scene or action taking place. Format the response with each new speaker on a new line.<<CHUNK>>"},
       ]
		)
}

const OPENAI_Scene_Characters = async (job,state) => {
		OPENAI_Scene_Process(job,state,
		  [
          {role:'system',content:'You are a helpful assistant who understands the main characters in books and ignores html tags.'},
          {role:'user',content:'This book is narrated by Ayaka'},
          {role:'user',content:'You return only valid JSON with no other text. Each character has JSON of the form {firstname:Ayaka,lastname:Whoever,aliases[one,two],attributes[happy,sad]},'},
          {role:'system', content:'Here is what we know so far: <<SOFAR>>'},
          {role:'user',content:"List all characters and their attributes in the following text:/n/n<<CHUNK>>/nJSON LIST OF CHARACTERS"},
       ]
		)
		/*
	console.log("AND the job is.......",job)

  const storyAsset = job.assets.find((a)=>a.asset === "Story")
  const scenesAsset = job.assets.find((a)=>a.asset === "Scene")

  const story = await getFromStorage(storyAsset.data.primary.value,state)
  const temp = "params" in job && "temp" in job.params ? job.params.temp : 0.3
  console.log("TEMPERATURE IS",temp)

	const response = {
		  display: "Scene to Characters",
	    ProviderName: "OpenAI",
	    ProviderID: "OpenAI Key",
	    Billing: 0,
  }
  const scenes = scenesAsset.data.entries
  const al = Array.isArray(job.service.outputs) ? job.service.outputs : [job.service.outputs]	// Should be ["Summary"] in this case
  const al0 = al[0]
  const al00 = al0.split('.')
  const al00n = al00[al00.length-1]
  console.log("Scene2Characters generates",al);
  const newdata = []
  var i = 0
  while (i<scenes.length) {
  	console.log("First scene to go is",story.substr(scenes[i].start,scenes[i].end))
  	 const result = await openAI_chunk_and_run(
      story.substr(scenes[i].start,scenes[i].end),  // content
      [
          {role:'system',content:'You are a helpful assistant who understands the main characters in books and ignores html tags.'},
          {role:'user',content:'This book is narrated by Ayaka'},
          {role:'user',content:'You return only valid JSON with no other text. Each character has JSON of the form {firstname:Ayaka,lastname:Whoever,aliases[one,two],attributes[happy,sad]},'},
          {role:'user',content:"List all characters and their attributes in the following text:/n/n<<CHUNK>>/nJSON LIST OF CHARACTERS"},
        ],
      temp,  // temp
      state,
    )
  	const newentry = {id:scenes[i].id}
  	newentry[al00n] = result
  	newdata.push(newentry)
  	i = i+1;
  }
  response.entries = newdata
  console.log("Sending summary response",response.length)
	await sendResult(job,response,state) 
	*/
}


// ==== Story 2 Charachter

const Story2Character = async (job,state) => {
	// https://www.assemblyai.com/blog/6-best-named-entity-recognition-apis-entity-detection/
	return new Promise (async resolve => {
			console.log("Story2Character")
			const response = {
				  display: "Character Designations",
			    ProviderName: "Orchestrate",
			    ProviderID: "Internal",
			    Designation: [
			        {display: "Ayaka", firstname:"Ayaka", lastname:"Turnbuilt"},
			        {display: "Millicent", firstname:"Millicent", lastname:"Strangewater", alias:["Milli"]},
			        {display: "Aly", firstname:"Aly", lastname:"Virjy"},
			        {display: "Dina", firstname: "Dina"},
			        {display: "Blob", firstname: "Blob"},
			        {display: "Blubber", firstname: "Blubber"},
			        {display: "Grace", firstname:"Grace"},
			        {display: "Pharook", firstname: "Pharook"},
			        {display: "Remma", firstname: "Remma", lastname:"Jain"},
			        ],
			    Billing: 0,
		  }
	    await sendResult(job,response,state).then(()=>resolve(true))
  })
}

const Story2GN = async (job,state) => {
	console.log("Story2GN")
	const response = {
		  display: "Graphic Novel",
	    ProviderName: "Orchestrate",
	    ProviderID: "Internal",
	    primary: 
	        {location: "Web",
	         type: "Page",
	         value: "https://www.tiltturntwist.com"
	        },
	    Billing: 0,
  }
	sendResult(job,response,state)
}

const Mixamo = async (job,state) => {
	console.log("Mixamo")
	const response = {
		  display: "Mixamo",
	    ProviderName: "Mixamo",
	    ProviderID: "Mixamo",
	    primary: 
	        {location: "Web",
	         type: "Page",
	         // value: "https://www.mixamo.com/#/"
	         value: "https://www.unamedia.com/ue4-mixamo/docs/mixamo-root-motion-animations/mixamo-in-place-animation-1150553d.png"
	        },
	    Billing: 0,
  }
	sendResult(job,response,state)
}

const Printer = async (job,state) => {
	console.log("Printer")
	const response = {
		  display: "Printer",
	    ProviderName: "Printer",
	    ProviderID: "Printer",
	    primary: 
	        {location: "Web",
	         type: "Page",
	         // value: "https://www.mixamo.com/#/"
	         value: "https://help.printify.com/hc/article_attachments/5600425160721/orderstatus1.png"
	        },
	    Billing: 0,
  }
	sendResult(job,response,state)
}

const Publisher = async (job,state) => {
	console.log("Printer")
	const response = {
		  display: "Printer",
	    ProviderName: "Printer",
	    ProviderID: "Printer",
	    primary: 
	        {location: "Web",
	         type: "Page",
	         // value: "https://www.mixamo.com/#/"
	         value: "https://www.sidehustlenation.com/wp-content/uploads/2017/09/Amazon-royalty-reporting.jpg"
	        },
	    Billing: 0,
  }
	sendResult(job,response,state)
}

const StableDiffusion = async (job,state) => {
	console.log("Stable Diffusion")
	const response = {
		  display: "Stable Diffusion",
	    ProviderName: "Stable Diffusion",
	    ProviderID: "Stable Diffusion",
	    primary: 
	        {location: "Web",
	         type: "Page",
	         value: "https://i0.wp.com/stable-diffusion-art.com/wp-content/uploads/2023/02/image-22-e1675832572504.png?resize=1024%2C545&ssl=1"
	        },
	    Billing: 0,
  }
	sendResult(job,response,state)
}

const RealAllusion = async (job,state) => {
	console.log("Stable Diffusion")
	const response = {
		  display: "Stable Diffusion",
	    ProviderName: "Stable Diffusion",
	    ProviderID: "Stable Diffusion",
	    primary: 
	        {location: "Web",
	         type: "Page",
	         value: "https://forum.reallusion.com/uploads/images/7ec4f8e1-28c4-48e6-a974-c926.png"
	        },
	    Billing: 0,
  }
	sendResult(job,response,state)
}

/// == Story 2 Index === 

const Story2IndexFunction = (story) => {
	console.log("==== 1 ===== In Story2Index")
	console.log("==== 2 ===== In Story2Index with",story.substr(0,50))
  var index = -1
  const h1s = []
  while ((index = story.indexOf("<h1>", index+1)) !== -1) {h1s.push(index)}
  index = -1
  const h1e = []
  while ((index = story.indexOf("</h1>", index+1)) !== -1) {h1e.push(index)}

  const chs = []
  index = 0
  while (index < h1s.length) {
    chs.push({display:story.substr(h1s[index]+4,(h1e[index]-h1s[index])-4), 
              start:h1e[index]+5, 
              end: (index +1) < h1s.length ? h1s[index+1] : story.length
            })
    index = index + 1
  }
	console.log("==== 3 ===== In Story2Index with",chs.length)
	if (chs.length === 0) chs.push({display:"Full Story",start:0,end:story.length})
  return chs
}

const Story2Index = async (job,state) => {
	var story = await getFromStorage(job.assets[0].data.primary.value,state)
    const index = Story2IndexFunction(story)
    const response = {
    		display: "Scene Indexes",
    		ProviderName: "Orchestrate",
    		providerID: "Internal",
    		Index: index,
    		Billing: 0
    }
    sendResult(job,response,state)
}

const Scene2Summary = async (job,state) => {
	console.log("Scene2Summary");
	const response = {
		  display: "Scene to Summary",
	    ProviderName: "OpenAI",
	    ProviderID: "OpenAI Key",
	    Billing: 0,
  }
  const scenes = job.assets[0].data.entries
  const al = Array.isArray(job.service.outputs) ? job.service.outputs : [job.service.outputs]	// Should be ["Summary"] in this case
  const al0 = al[0]
  const al00 = al0.split('.')
  const al00n = al00[al00.length-1]
  console.log("Scene2Summary generates",al);
  const newdata = []
  scenes.forEach((s)=>{
  	const newvalue = "Stub"
  	const newentry = {id:s.id}
  	newentry[al00n] = newvalue
  	newdata.push(newentry)
  })
  response.entries = newdata
  console.log("Sending summary response",response.length)
	sendResult(job,response,state) 
}

const StubResponse = async (job,state) => {
	console.log("^^^^^^^^StubResponse^^^^^^^^",JSON.stringify(job));
	console.log("StubResponse---Service",JSON.stringify(job.service))
	const response = {
		  display: "Job not handled yet: to be implemented",
	    ProviderName: "Stub",
	    ProviderID: "Stub",
	    Billing: 0,
  }
  const al = Array.isArray(job.service.outputs) ? job.service.outputs : [job.service.outputs]
  console.log("StubResponse al",al);
  al.forEach((asset)=>{
  	response[asset] = "Stub"
  })
  console.log("Sending stub response",response)
	sendResult(job,response,state) 
}

const FakeScript = async (job,state) => {
	const script = "<p>EXT. NEW BEDFORD HARBOR - DAY</p><p>The year is 1840. We see a whaling ship, the Pequod, entering the harbor. On board, we see CAPTAIN AHAB, a tall and imposing figure, with a wooden leg, standing on the deck, looking out to the sea.</p><p>CAPTAIN AHAB (to his crew) Welcome to New Bedford, men. We have a whale to catch.</p><p>The crew cheers.</p><p>CUT TO:</p><p>INT. THE PEQUOD - DAY</p><p>The crew is preparing for the voyage. We see ISHMAEL, a young sailor, getting ready for his first whaling trip.</p><p>ISHMAEL (to a fellow sailor) I hope I can make it through this voyage.</p><p>FELLOW SAILOR (to Ishmael) Don't worry, lad. You'll get used to it.</p><p>Suddenly, Captain Ahab enters the room. The crew stands at attention.</p><p>CAPTAIN AHAB (to the crew) Men, we're not just hunting for whales. We're hunting for one whale in particular. The white whale. Moby Dick.</p><p>The crew looks at each other in disbelief.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The ship is sailing in open waters. The crew is busy with their duties, but Ishmael is looking out to the sea, thinking about the captain's obsession with Moby Dick.</p><p>ISHMAEL (to himself) What kind of whale could make a man so obsessed?</p><p>Suddenly, a harpoon is thrown, hitting a nearby whale. The crew begins to pull the whale on board.</p><p>CUT TO:</p><p>INT. THE PEQUOD - DAY</p><p>The crew is cutting up the whale, extracting the valuable blubber. Ishmael is disgusted by the sight.</p><p>ISHMAEL (to a fellow sailor) How can we do this? These creatures are magnificent.</p><p>FELLOW SAILOR (to Ishmael) It's the life we chose, lad.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - NIGHT</p><p>The ship is sailing through a storm. The crew is struggling to keep the ship afloat. Ishmael is holding on to the mast, trying not to fall overboard.</p><p>ISHMAEL (to himself) This is madness. What are we doing out here?</p><p>Suddenly, a loud crash is heard. The ship has hit something.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The crew is looking overboard, trying to see what they hit. Captain Ahab is looking through his telescope.</p><p>CAPTAIN AHAB (to the crew) It's him. Moby Dick.</p><p>The crew is terrified.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The ship is being chased by Moby Dick. The crew is trying to harpoon him, but he's too fast.</p><p>CAPTAIN AHAB (to the crew) We can't let him get away. We have to kill him.</p><p>The crew is hesitant, but they follow the captain's orders.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The crew is attacking Moby Dick with everything they have. The whale is fighting back, destroying the ship.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The ship is sinking. The crew is trying to escape on lifeboats. Captain Ahab is still fighting Moby Dick, refusing to give up.</p><p>CAPTAIN AHAB (to Moby Dick) You won't get away from me, you monster.</p><p>Suddenly, Moby Dick attacks the captain, killing him instantly.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p>"
	console.log("Script")
	const response = {
		  display: "Job not handled yet: to be implemented",
	    ProviderName: "Stub",
	    ProviderID: "Stub",
	    Billing: 0,
	    Script: {location:"Local", value:script, type:"html"}
  }
	sendResult(job,response,state) 
}

const FakeScreenplay = async (job,state) => {
	const screenplay = "<p>FADE IN:</p><p>EXT. NEW BEDFORD HARBOR - DAY</p><p>The year is 1840. We see a whaling ship, the Pequod, entering the harbor. On board, we see CAPTAIN AHAB, a tall and imposing figure, with a wooden leg, standing on the deck, looking out to the sea.</p><p>CAPTAIN AHAB (to his crew) Welcome to New Bedford, men. We have a whale to catch.</p><p>The crew cheers.</p><p>CUT TO:</p><p>INT. THE PEQUOD - DAY</p><p>The crew is preparing for the voyage. We see ISHMAEL, a young sailor, getting ready for his first whaling trip.</p><p>ISHMAEL (to a fellow sailor) I hope I can make it through this voyage.</p><p>FELLOW SAILOR (to Ishmael) Don't worry, lad. You'll get used to it.</p><p>Suddenly, Captain Ahab enters the room. The crew stands at attention.</p><p>CAPTAIN AHAB (to the crew) Men, we're not just hunting for whales. We're hunting for one whale in particular. The white whale. Moby Dick.</p><p>The crew looks at each other in disbelief.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The ship is sailing in open waters. The crew is busy with their duties, but Ishmael is looking out to the sea, thinking about the captain's obsession with Moby Dick.</p><p>ISHMAEL (to himself) What kind of whale could make a man so obsessed?</p><p>Suddenly, a harpoon is thrown, hitting a nearby whale. The crew begins to pull the whale on board.</p><p>CUT TO:</p><p>INT. THE PEQUOD - DAY</p><p>The crew is cutting up the whale, extracting the valuable blubber. Ishmael is disgusted by the sight.</p><p>ISHMAEL (to a fellow sailor) How can we do this? These creatures are magnificent.</p><p>FELLOW SAILOR (to Ishmael) It's the life we chose, lad.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - NIGHT</p><p>The ship is sailing through a storm. The crew is struggling to keep the ship afloat. Ishmael is holding on to the mast, trying not to fall overboard.</p><p>ISHMAEL (to himself) This is madness. What are we doing out here?</p><p>Suddenly, a loud crash is heard. The ship has hit something.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The crew is looking overboard, trying to see what they hit. Captain Ahab is looking through his telescope.</p><p>CAPTAIN AHAB (to the crew) It's him. Moby Dick.</p><p>The crew is terrified.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The ship is being chased by Moby Dick. The crew is trying to harpoon him, but he's too fast.</p><p>CAPTAIN AHAB (to the crew) We can't let him get away. We have to kill him.</p><p>The crew is hesitant, but they follow the captain's orders.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The crew is attacking Moby Dick with everything they have. The whale is fighting back, destroying the ship.</p><p>CUT TO:</p><p>EXT. THE PEQUOD - DAY</p><p>The ship is sinking. The crew is trying to escape on lifeboats. Captain Ahab is still fighting Moby Dick, refusing to give up.</p><p>CAPTAIN AHAB (to Moby Dick) You won't get away from me, you monster.</p><p>Suddenly, Moby Dick attacks the captain, killing him instantly.</p>"
	console.log("Screenplay")
	const response = {
		  display: "Job not handled yet: to be implemented",
	    ProviderName: "Stub",
	    ProviderID: "Stub",
	    Billing: 0,
	    Screenplay: {location:"Local", value: screenplay, type: "html"}
  }
	sendResult(job,response,state) 
}


export async function runInBrowser (job,state) {
	  console.log("Checking job",job.assets[0].asset,job.service.outputs)
	  return new Promise (async resolve => {
		  	switch (job.assets[0].asset) {
		  	case "Story":
				  		switch (job.service.outputs) {
				  		case "Character.*.Designation": await Story2Character(job,state); resolve(true); break;
				  		case "Scene.*.Index": 					await Story2Index(job,state); resolve(true); break;
				  		case "GraphicNovel":					  await Story2GN(job,state); resolve(true); break;
				  		case "StoryBoard":					    await Story2GN(job,state); resolve(true); break;
				  		case "Story.Summary":						await OPENAI_Story_Summary(job,state); resolve(true); break;
				  //		case "Entities":							  resolve (GOOGLE_Langauge(job,state); resolve(true); break;
				  		default: console.log("NO MATCH HERE"); resolve(false)
				  		}
		  		break;
		  	case "Scene":
		 		  		switch (job.service.outputs) {
				  		case "Scene.*.Summary": 				await OPENAI_Scene_Summary(job,state); resolve(true); break; // await Scene2Summary(job,state); resolve(true); break;
				  		case "Scene.*.Characters": 			await OPENAI_Scene_Characters(job,state); resolve(true); break; // await Scene2Summary(job,state); resolve(true); break;
				  		case "Scene.*.Locations": 			await OPENAI_Scene_Locations(job,state); resolve(true); break; // await Scene2Summary(job,state); resolve(true); break;
				  		case "Scene.*.Dialog": 			    await OPENAI_Scene_Dialog(job,state); resolve(true); break; // await Scene2Summary(job,state); resolve(true); break;
				  		default: resolve(false)
				  		}
		 		break;
		  	case "Character":
		 		  		switch (job.service.outputs) {
				  		case "Character.Animation":     await Mixamo(job,state); resolve(true); break;
				  		case "Character.Image":					await StableDiffusion(job,state); resolve(true); break;
				  		case "CharacterDashboard":			await RealAllusion(job,state); resolve(true); break;
				  		case "Script":									await FakeScript(job,state); resolve(true); break;
				  		case "Screenplay":							await FakeScreenplay(job,state); resolve(true); break;
				  		default: resolve(false);
				  		}
		 		break;
		 		case "GraphicNovel":
		 		  		switch (job.service.outputs) {
				  		case "PhysicalBook":     				await Printer(job,state); resolve(true); break;
				  		case "BN_Dashboard":					  await Publisher(job,state); resolve(true); break;
				  		default: resolve(false);
				  		}
		 		break;
		  	default: 
		  		console.log ("NO MATCH for IN BROWSER")
		  		resolve(false); 
		  	break;
		  	}
		  	resolve(false)
  })
}

